export default __webpack_public_path__ + "static/site-header-layout-bg-f832df13726095bad4fd6cc4f4d7d3f7.png";